// "알림 설정" - 알림 종류별 푸시 on/off(SYS_USR_PUSH_PREF) + 이 기기의 푸시 등록 상태 표시.
// 프로필(/profile) 화면에 둔다 - 사용자별 개인 설정이라 그리드 개인화(gridPref)와 같은 자리.
import React, { useEffect, useState } from 'react';
import { Box, FormControlLabel, Switch, Typography, Chip, Stack, CircularProgress } from '@mui/material';
import { useSnackbar } from 'notistack';
import * as pushApi from '../../lib/api/push';
import { isNativePushCapable, hasRegisteredPushToken } from '../../lib/nativePush';

const PushSettings = () => {
  const { enqueueSnackbar } = useSnackbar();
  const [prefs, setPrefs] = useState(null); // [{ notiTyp, label, enabled }]
  const [loading, setLoading] = useState(true);
  const [savingTyp, setSavingTyp] = useState(null);

  useEffect(() => {
    let active = true;
    (async () => {
      try {
        const res = await pushApi.fetchPushPrefs();
        if (active) setPrefs(res.data.list || []);
      } catch (e) {
        if (active) {
          enqueueSnackbar('알림 설정을 불러오지 못했습니다.', { variant: 'error' });
        }
      } finally {
        if (active) setLoading(false);
      }
    })();
    return () => {
      active = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleToggle = async (notiTyp, nextEnabled) => {
    // 낙관적 업데이트 - 실패하면 되돌린다.
    setPrefs((prev) => prev.map((p) => (p.notiTyp === notiTyp ? { ...p, enabled: nextEnabled } : p)));
    setSavingTyp(notiTyp);
    try {
      await pushApi.savePushPref(notiTyp, nextEnabled);
    } catch (e) {
      setPrefs((prev) => prev.map((p) => (p.notiTyp === notiTyp ? { ...p, enabled: !nextEnabled } : p)));
      enqueueSnackbar('저장에 실패했습니다.', { variant: 'error' });
    } finally {
      setSavingTyp(null);
    }
  };

  const deviceStatus = isNativePushCapable()
    ? (hasRegisteredPushToken() ? { label: '이 기기 푸시 받는 중', color: 'success' } : { label: '이 기기 푸시 미등록', color: 'default' })
    : { label: '앱(모바일)에서만 지원', color: 'default' };

  return (
    <Box>
      <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 1.5 }}>
        <Typography variant="body2" color="text.secondary">
          이 기기
        </Typography>
        <Chip size="small" label={deviceStatus.label} color={deviceStatus.color} variant="outlined" />
      </Stack>

      {loading ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', py: 2 }}>
          <CircularProgress size={20} />
        </Box>
      ) : (
        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
          {(prefs || []).map((pref) => (
            <FormControlLabel
              key={pref.notiTyp}
              sx={{ justifyContent: 'space-between', ml: 0, py: 0.25 }}
              labelPlacement="start"
              control={
                <Switch
                  checked={pref.enabled}
                  disabled={savingTyp === pref.notiTyp}
                  onChange={(e) => handleToggle(pref.notiTyp, e.target.checked)}
                />
              }
              label={<Typography variant="body2">{pref.label}</Typography>}
            />
          ))}
        </Box>
      )}
    </Box>
  );
};

export default PushSettings;
